import React from 'react';
import UserManagementStore from '../../stores/UserManagementStore';
import { getBrandId, isVMBusiness } from '../../utils/BrandUtils';
import SvgIcon from '../common/SvgIcon';

const Icon = ({ id }) => <SvgIcon id={id} width="24px" height="24px" />;

const getPhoneNumber = () => {
  if (UserManagementStore.isSMEUser()) {
    return {
      B: '0800 121 7365',
      VM: '0800 756 0800',
      CB: '0800 345 7 365',
      YB: '0800 456 1247',
    };
  }
  return {
    B: '0800 121 7365',
    VM: '0800 121 7365',
    CB: '0800 345 7 365',
    YB: '0800 456 1247',
  };
};

export const help = (content) => ({
  image: <Icon id="icon-chat" />,
  heading: content.getHelp,
  body: (
    <span>
      {content.getHelpData} <strong>{getPhoneNumber()[getBrandId()]}</strong>.
    </span>
  ),
});

export const spendings = (content) => ({
  image: <Icon id="icon-spending" />,
  heading: content.trackYourSpending,
  body: content.trackYourSpendingData,
});

export const statements = (content) => ({
  image: <Icon id="icon-statements" />,
  heading: content.statements,
  body: content.statementsData,
});

export const alerts = (content) => ({
  image: <Icon id="icon-alert" />,
  heading: content.freeAlerts,
  body: isVMBusiness() ? content.freeAlertsDataSME : content.freeAlertsData,
});

export const interest = (content, isSME, handleOnClick) => ({
  image: <Icon id="icon-interest" />,
  heading: content.earnInterest,
  body: (
    <div>
      <span>{content.earnInterestText}</span>
      <a
        href={isSME ? content.earnInterestLinkSME : content.earnInterestLink}
        onClick={(e) => handleOnClick(e, 1)}
        aria-haspopup="true"
      >
        <span>
          {isSME
            ? content.earnInterestLinkTextSME
            : content.earnInterestLinkText}
        </span>
      </a>
    </div>
  ),
});

export const overdraft = (content, handleOnClick) => ({
  image: <Icon id="icon-loans" />,
  heading: content.overdraft,
  body: (
    <div>
      <span>{content.overdraftText}</span>
      <a
        href={content.overdraftLink}
        onClick={(e) => handleOnClick(e, 2)}
        aria-haspopup="true"
      >
        <span>{content.overdraftLinkText}</span>
      </a>
    </div>
  ),
});

export const projections = (content) => ({
  image: <Icon id="icon-projections" />,
  heading: content.projections,
  body: content.projectionsData,
});

export const sweeps = (content) => ({
  image: <Icon id="icon-exit" />,
  heading: content.sweeps,
  body: content.sweepsData,
});

export const savingsPot = (content) => ({
  image: <Icon id="icon-goal" />,
  heading: content.createSavingPots,
  body: content.createSavingPotsData,
});
